define('lq/events/actions/logoffCommand',[
    'lq',
    'lq/storage',
    'lq/events/actions/eventAction'
], function (lq, storage, EventAction) {
    'use strict';

    function LogoffCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(LogoffCommand, EventAction);

    LogoffCommand.typeName = 'LogoffCommand';

    LogoffCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    LogoffCommand.prototype.execute = function (continuation) {
        var self = this;
        this.piping.dispatcher.dispatch('LicquidAction/LogOff')
            .done(function (result) {
                if (storage.localStorageIsAvailable()) {
                    localStorage.removeItem('licquidAuthCookie');
                    localStorage.removeItem('licquidAuthCommandId');
                }

                if (result && result.isFederated) {
                    window.location = lq.getTenantUrl('FederatedLogin/Logout');
                }
                else if (self.eventIsEnabled('userLoggedOff'))
                    self.piping.dispatcher.refreshCsrfToken(function () {
                        self.triggerEvent('userLoggedOff', continuation);
                    });
                else
                    window.location = lq.getTenantUrl('');
            });
    };

    return LogoffCommand;
});
